import { render } from "./AposDocEditor.vue?vue&type=template&id=383a5f1c&scoped=true"
import script from "./AposDocEditor.vue?vue&type=script&lang=js"
export * from "./AposDocEditor.vue?vue&type=script&lang=js"

import "./AposDocEditor.vue?vue&type=style&index=0&id=383a5f1c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-383a5f1c"],['__file',"doc-type/ui/apos/components/AposDocEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "383a5f1c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('383a5f1c', __exports__)) {
    api.reload('383a5f1c', __exports__)
  }
  
  module.hot.accept("./AposDocEditor.vue?vue&type=template&id=383a5f1c&scoped=true", () => {
    api.rerender('383a5f1c', render)
  })

}


export default __exports__